<template>
  <div id="paypal-success" class="container">
    <h3>Esecuzione pagamento paypal</h3>

    <div v-if="paypalStatus === -1" id="paypal-desc" class="col-xs-12">
      Si sta eseguendo la transazione del pagamento
    </div>
    <div v-else-if="paypalStatus === 0" id="paypal-desc" class="col-xs-12">
      Ci sono stati dei problemi durante l'esecuzione del pagamento
    </div>
    <div v-else="paypalStatus === 1" id="paypal-desc" class="col-xs-12">
      Il pagamento tramite paypal &egrave; avvenuto con successo!

      <div v-if="!checkoutAndMailSuccess" id="checkout-and-mail">
        Sono avvenuti dei problemi con l'invio della mail di riepilogo
      </div>
    </div>

    <div class="go-gome" v-if="paypalStatus !== -1">
      <input class="btn btn-md btn-stroke button-blu-effect right go-back button-new-style"
             type="submit" value="Torna al carrello" v-on:click="goHome()">
    </div>
  </div>
</template>

<script>
  const axios = require('axios')

  export default {
    name: 'PaypalResultDone',
    data () {
      return {
        paypalStatus: -1,
        checkoutAndMailSuccess: false
      }
    },
    mounted: function () {
      this.executePayment()
    },
    methods: {
      getIdCart: function () {
        return this.$route.params.id_cart
      },
      executePayment: function () {
        if (this.$route.query && this.$route.query.paymentId && this.$route.query.paymentId !== '' && this.$route.query.PayerID && this.$route.query.PayerID !== '' && this.getIdCart() !== '') {
          axios.post('/api/v1/carts/' + this.getIdCart() + '/paypal/execute/payment_id/' + this.$route.query.paymentId + '/payer_id/' + this.$route.query.PayerID)
            .then(resp => {
              if (resp.status === 200) {
                if (resp.data.result.paymentPaymentExecuted) {
                  this.$router.replace({query: null})
                  this.paypalStatus = 1
                  this.checkoutAndMailSuccess = resp.data.result.checkoutAndMail
                  localStorage.removeItem('id_cart')
                } else {
                  this.paypalStatus = 0
                }
              } else {
                this.paypalStatus = 0
              }
            })
            .catch(err => {
              this.paypalStatus = 0
            })
        }
      },
      goHome: function () {
        this.$router.push({name: 'e3d'})
      }
    }
  }
</script>

<style lang="less">
  #paypal-success {
    color: #424242;
    font-size: 14px;
    font-family: "Open Sans", sans-serif;
    height: 300px;

    #paypal-desc {
      margin-top: 20px;
      padding: 0;

      #checkout-and-mail {
        padding-top: 10px;
      }
    }

    .button-new-style {
      background-color: #4285F4;
      border-radius: 15px;
      color: white;
      font-weight: bold;
      width: 200px;
      padding: 0;

      &:hover {
        background-color: #004B96;
        border: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PaypalResultDone.vue